module.exports = __webpack_public_path__ + "fb60d22eae65ee917e981883be773334.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/Sample-Criminal-Report.png
// module id = 628
// module chunks = 0